import React, {
  Dispatch,
  useContext,
  createContext,
  useState,
  SetStateAction,
} from "react";

export interface IThemeContext {
  isDarkMode: boolean;
  setIsDarkMode: Dispatch<SetStateAction<boolean>>;
  transitionPercent: number;
  setTransitionPercent: Dispatch<SetStateAction<boolean>>;
}

const ThemeViewContext = createContext({
  currentMode: false,
  setCurrentMode: (isDarkMode: boolean) => {},
  currentTransitionPercent: 0,
  setCurrentTransitionPercent: (transitionPercent: number) => {},
});

export const useThemeContext = () => {
  return useContext(ThemeViewContext);
};

export const ThemeContext = ({ children }: any) => {
  const [isDarkmode, setIsDarkMode] = useState<boolean>(false);
  const [transitionPercent, setTransitionPercent] = useState<number>(0);

  return (
    <ThemeViewContext.Provider
      value={{
        currentMode: isDarkmode,
        setCurrentMode: setIsDarkMode,
        currentTransitionPercent: transitionPercent,
        setCurrentTransitionPercent: setTransitionPercent,
      }}
    >
      {children}
    </ThemeViewContext.Provider>
  );
};

export default ThemeContext;
